import axios from 'axios'
import {ApiResponse} from '../models/Base'
import { ParamMasterDto, UploadResponse } from '../models/dto/Commons'
import { ImageTypeCode } from '../state/types'


const API_URL = process.env.REACT_APP_API_URL
const COMMON_URL = `${API_URL}/commons`

export function getMasterParams() {
  return axios.get<ApiResponse<ParamMasterDto[]>>(`${COMMON_URL}/params`)
}

export function getMasterParam(paramTypeId: number) {
  return axios.get<ApiResponse<ParamMasterDto[]>>(`${COMMON_URL}/params/${paramTypeId}`)
}

export function getMasterParamByName(name: string) {
  return axios.get<ApiResponse<ParamMasterDto[]>>(`${COMMON_URL}/params/types/${name}`)
}
export function getMasterParamByNames(typeNames: string[]) {
  return axios.post<ApiResponse<ParamMasterDto[]>>(`${COMMON_URL}/params/typeNames`, typeNames)
}
export function getMasterParamIds(ids: number[]) {
  return axios.post<ApiResponse<ParamMasterDto[]>>(`${COMMON_URL}/params/ids`, ids)
}



export function uploadFile(code: ImageTypeCode, file: File) {
  const formData = new FormData()
  formData.append('file', file)
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }

  return axios.post<ApiResponse<UploadResponse>>(
    `${COMMON_URL}/files/${code}/upload`,
    formData,
    config
  )
}

export function uploadFiles(code: ImageTypeCode, files: File[]) {
  const formData = new FormData()

  files.forEach((file, index) => {
    formData.set(`files-${index}`, file, file.name)
  })
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }
  return axios.post<ApiResponse<UploadResponse[]>>(
    `${COMMON_URL}/files/${code}/uploads`,
    formData,
    config
  )
}